module.exports = __webpack_public_path__ + "static/media/presentation.313a9e4c.png";